export default __webpack_public_path__ + "static/naval-history-f791814f6951ec75668c9bf5603acb7b.jpg";